var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedinLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2188 3.09375H3.78125C3.40155 3.09375 3.09375 3.40155 3.09375 3.78125V18.2188C3.09375 18.5984 3.40155 18.9062 3.78125 18.9062H18.2188C18.5984 18.9062 18.9062 18.5984 18.9062 18.2188V3.78125C18.9062 3.40155 18.5984 3.09375 18.2188 3.09375Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.3125 9.625V15.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.5625 9.625V15.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.3125 12.0312C10.3125 11.3931 10.566 10.781 11.0173 10.3298C11.4685 9.87852 12.0806 9.625 12.7188 9.625C13.3569 9.625 13.969 9.87852 14.4202 10.3298C14.8715 10.781 15.125 11.3931 15.125 12.0312V15.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.5625 7.5625C7.9422 7.5625 8.25 7.2547 8.25 6.875C8.25 6.4953 7.9422 6.1875 7.5625 6.1875C7.1828 6.1875 6.875 6.4953 6.875 6.875C6.875 7.2547 7.1828 7.5625 7.5625 7.5625Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedinLogo.c85e2cb11b7849ba19ad87a4efb668f3.svg";
export { ForwardRef as ReactComponent };